var $ = jQuery.noConflict()

$(document).ready(function() {
	Debug.log("_______________ GLOBAL.JS INITIALISATION _______________");

	Reveals.init();
	Menu.init();	
	FullHeight.init();

	if(Config.debug_mode == true){
		Debug.init();	
	}

	var template = $('#content').attr('data-template');
	//Debug.log("TEMPLATE : " + template);
	switch(template){
		case "homepage":

			break;
		default:

			break;
								 }


});

(function () {
    window.onpageshow = function(event) {
        if (event.persisted) {
            window.location.reload();
        }
    };
})();